import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-111">
      <div className="max-w-4xl mx-auto text-center" data-id="element-112">
        {/* Logo */}
        <div className="text-[#00B4D8] text-3xl font-black tracking-widest mb-8" data-id="element-113">
          🎾 EDULABS™
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-114">
          El próximo lunes puedes volver a improvisar la clase.
        </h2>
        <p className="text-[#00B4D8] text-2xl sm:text-3xl font-black mb-10" data-id="element-115">
          O puedes entrar a la cancha con todo resuelto desde hoy.
        </p>

        {/* Cost Table */}
        <div className="bg-[#001a2d] border border-[#00B4D8]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-116">
          <div className="p-4 bg-[#000d1a] border-b border-[#00B4D8]/30 text-center font-bold text-white" data-id="element-117">
            ¿Cuánto cuesta NO tenerlo?
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 bg-[#000d1a] border-b border-[#00B4D8]/30" data-id="element-118">
            <div className="p-4 font-bold text-gray-400 text-center" data-id="element-119">
              SIN MEGAPACK
            </div>
            <div className="p-4 font-bold text-[#00B4D8] text-center sm:border-l border-[#00B4D8]/30" data-id="element-120">
              CON MEGAPACK
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-121">
            <div className="p-4 text-gray-400 text-sm" data-id="element-122">
              100+ horas/año planificando desde cero
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-123">
              10 min/semana. El resto es enseñar.
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-124">
            <div className="p-4 text-gray-400 text-sm" data-id="element-125">
              Drills improvisados → mismo error por meses
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-126">
              60 drills listos → se resuelve en la clase
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-127">
            <div className="p-4 text-gray-400 text-sm" data-id="element-128">
              60% de abandono antes del año
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-129">
              Sistema de fidelización → retención +75%
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-130">
            <div className="p-4 text-gray-400 text-sm" data-id="element-131">
              Sin progresión clara por nivel
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-132">
              6 tomos con niveles progresivos → suben y recomiendan
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-133">
            <div className="p-4 text-gray-400 text-sm" data-id="element-134">
              Lluvia = cancelación = sin cobro
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-135">
              Kit Anti-Lluvia: 12 clases Plan B listas
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-136">
            <div className="p-4 text-gray-400 text-sm" data-id="element-137">
              Niveles mezclados = caos
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-138">
              6 rotaciones listas → todos mejoran juntos
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-139">
            <div className="p-4 text-gray-400 text-sm" data-id="element-140">
              Cobro irregular e incómodo
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-141">
              Abono blindado → cobras el día 1-5
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-142">
            <div className="p-4 text-gray-400 text-sm" data-id="element-143">
              Sin identidad profesional
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-144">
              Sistema de negocio que justifica cobrar más
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-145">
            <div className="p-4 text-gray-400 text-sm" data-id="element-146">
              Contrato verbal que termina en conflicto
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-147">
              Reglamento + Contrato Ético listos para usar
            </div>
          </div>
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-148">
          <p className="text-white font-bold mb-4" data-id="element-149">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-150" />
        </div>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-151">
          <div className="bg-[#0a0a0a] border border-[#00B4D8]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-152">
            <div className="text-2xl mb-2" data-id="element-153">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-154">MEGAPACK PADEL LISTO</h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-155">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-156">
              <p className="text-gray-400 line-through text-sm mb-1" data-id="element-157">
                Antes: USD $24.90
              </p>
              <p className="text-[#00B4D8] text-2xl font-black mb-4" data-id="element-158">
                Hoy: USD $13.90
              </p>
              <a href="https://docentes2.edulabs.online/cart/43239355809910:1" className="btn-green-pulse block bg-[#00B4D8] font-black py-4 rounded-lg hover:bg-[#38BDF8] transition-colors text-sm text-[#FFFFFF]" data-id="element-159">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          <div className="bg-[#000d1a] border-2 border-[#00B4D8] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(0,180,216,0.2)] flex flex-col" data-id="element-160">
            <div className="text-2xl mb-2" data-id="element-161">🏆</div>
            <h3 className="text-[#00B4D8] font-black mb-1" data-id="element-162">
              MEGAPACK + PÁDEL PRO BUSINESS ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-1" data-id="element-163">La más elegida</p>
            <p className="text-gray-400 text-xs mb-4" data-id="element-164">
              6 Tomos + 6 Bonos + Pádel Pro Business™
              <br data-id="element-165" />
              (cobro, clínicas, captación y negocio)
            </p>
            <div className="mt-auto" data-id="element-166">
              <p className="text-gray-400 line-through text-sm mb-1" data-id="element-167">
                Antes: USD $30.90
              </p>
              <p className="text-[#00B4D8] text-3xl font-black mb-4" data-id="element-168">
                Hoy: USD $19.90
              </p>
              <a href="https://docentes2.edulabs.online/cart/43239356039286:1" className="btn-green-pulse block bg-[#00B4D8] font-black py-4 rounded-lg hover:bg-[#38BDF8] transition-colors text-sm text-[#FFFFFF]" data-id="element-169">
                → QUIERO EL MEGAPACK + PÁDEL PRO BUSINESS
              </a>
            </div>
          </div>
        </div>

        {/* Currency note */}
        <p className="text-gray-400 text-xs text-center mb-6 bg-[#0a0a0a] border border-[#00B4D8]/20 rounded-xl py-3 px-4 max-w-2xl mx-auto" data-id="element-170">
          💡 <strong data-id="element-171">Nota sobre el pago:</strong> Los precios están expresados
          en dólares estadounidenses (USD). El cobro se realizará
          automáticamente en la moneda de tu país al tipo de cambio
          correspondiente al momento de la compra. Puedes pagar con tarjeta de
          crédito, débito o transferencia bancaria desde cualquier país
          hispanohablante.
        </p>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-172">
          <span data-id="element-173">🔒 Pago 100% seguro</span>
          <span data-id="element-174">⚡ Acceso en 5 minutos</span>
          <span data-id="element-175">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-176">💳 Tarjeta de crédito | PayPal | Transferencia bancaria</span>
        </div>
      </div>
    </section>;
}